import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Row, Col, Table, Typography, Image, Space, Tag, Card, Alert } from 'antd'
import { checkPermission } from '../../../utils/permission';
import { isMobile } from 'react-device-detect';
import NumberFormat from 'react-number-format';
import HtmlParser from 'react-html-parser';
import { isValidDate, repeatPhoneNumber } from '../../../utils/helpers';
import HandlePhoneNumber from '../../../components/HandlePhoneNumber';

const { Paragraph } = Typography;

class CustomerServicesDetail extends Component {
    constructor() {
        super();
        this.state = {

        };
    }

    render() {
        var { visible, currentData } = this.props;

        const examination_visit_columns = [
            {
                title: 'Thời điểm khám',
                dataIndex: 'time',
                key: 'time',
                width: '20%',
                render: (text, record) => {
                    return (
                        <div>{isValidDate(text)}</div>
                    )
                }
            },
            {
                title: 'Bác sĩ khám',
                dataIndex: 'doctor_charge',
                key: 'doctor_charge',
                width: '25%'
            },
            {
                title: 'Phụ tá',
                dataIndex: 'assistant_doctor',
                key: 'assistant_doctor',
                width: '25%'
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '30%'
            }
        ];

        return (
            <>
                <Drawer
                    visible={visible}
                    title='Chi tiết dịch vụ'
                    onClose={() => this.props.onCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '50%'}
                >
                    {visible ? (
                        <>
                            {
                                currentData && currentData.type == 'CHOT' ? (
                                    <div>
                                        <Row gutter={16}>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Tên khách hàng">
                                                        {currentData ? currentData.customer_name : null}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Mã khách hàng">
                                                        <Paragraph style={{ margin: 0 }} copyable={
                                                            {
                                                                text: currentData ? currentData.customer_code : null,
                                                                tooltips: false
                                                            }
                                                        }>
                                                            <Tag color='#1890ff'>{currentData ? currentData.customer_code : null}</Tag>
                                                        </Paragraph>
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Số điện thoại">
                                                        {currentData ? (
                                                            <HandlePhoneNumber
                                                                permission={checkPermission('customer', 'phonenumber')}
                                                                inputPinCode={checkPermission('customer', 'input_pin_code')}
                                                                customer_id={currentData.customer_id}
                                                                hiddenPhoneNumber={repeatPhoneNumber(currentData?.customer_phone)}
                                                                fullPhoneNumber={currentData?.customer_phone}
                                                            />
                                                        ) : null}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Nguồn khách hàng">
                                                        {currentData ? currentData.customer_source : null}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Tên dịch vụ">
                                                        {currentData ? currentData.service_name : null}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Loại dịch vụ">
                                                        <Tag color='#03C03C'>Dịch vụ chốt</Tag>
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Giá gốc">
                                                        <NumberFormat value={currentData ? currentData.regular_price : 0} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Giá bán">
                                                        <NumberFormat value={currentData ? currentData.sale_price : 0} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Ngày chốt dịch vụ">
                                                        {currentData ? isValidDate(currentData.selected_at, false) : null}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Ngày tạo dịch vụ">
                                                        {currentData ? isValidDate(currentData.created_at) : null}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                                <Divider className="no-margin" />
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Descriptions size="small">
                                                    <Descriptions.Item label="Người tạo">
                                                        {currentData ? currentData.created_user : null}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                            </Col>
                                        </Row>
                                        <Row gutter={16} className='mt-3'>
                                            <Col xs={24} md={24}>
                                                <Alert
                                                    message={<span style={{ fontWeight: '600' }}>Ghi chú</span>}
                                                    description={currentData ? HtmlParser(currentData.note) : null}
                                                    type="info"
                                                    className='fix-alert-element'
                                                />
                                            </Col>
                                        </Row>
                                        <Row gutter={16} className='mt-4'>
                                            <Col xs={24} md={24} className='mb-2'>
                                                <Card size='small' className='border-dashed'>
                                                    <h6 className='h6-title'>Ảnh before</h6>
                                                    {
                                                        Array.isArray(currentData?.condition_before) && currentData.condition_before.length ? (
                                                            <Image.PreviewGroup>
                                                                <Space wrap>
                                                                    {
                                                                        currentData.condition_before.map((item, index) => {
                                                                            return (
                                                                                <Image
                                                                                    key={index}
                                                                                    height={50}
                                                                                    width={50}
                                                                                    src={item?.src}
                                                                                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                                                                                />
                                                                            )
                                                                        })
                                                                    }
                                                                </Space>
                                                            </Image.PreviewGroup>
                                                        ) : null
                                                    }
                                                </Card>
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Card size='small' className='border-dashed'>
                                                    <h6 className='h6-title'>Ảnh after</h6>
                                                    {
                                                        Array.isArray(currentData.condition_after) && currentData.condition_after.length ? (
                                                            <Image.PreviewGroup>
                                                                <Space wrap>
                                                                    {
                                                                        currentData.condition_after.map((item, index) => {
                                                                            return (
                                                                                <Image
                                                                                    key={index}
                                                                                    height={50}
                                                                                    width={50}
                                                                                    src={item?.src}
                                                                                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                                                                                />
                                                                            )
                                                                        })
                                                                    }
                                                                </Space>
                                                            </Image.PreviewGroup>
                                                        ) : null
                                                    }
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Table
                                            className='mt-4'
                                            size='small'
                                            dataSource={currentData.examination_visit || []}
                                            columns={examination_visit_columns}
                                            pagination={false}
                                            locale={{ emptyText: "Chưa có dữ liệu" }}
                                            scroll={{
                                                x: 'max-content'
                                            }}
                                        />
                                    </div>
                                ) : null
                            }
                        </>

                    ) : null}

                </Drawer>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerServicesDetail' })(CustomerServicesDetail));
